import React, { useEffect, useState } from "react";
import "./eventImageWithFallback.css";

function EventPosterPlaceholder() {
  return (
    <svg
      viewBox="0 0 91 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      <rect width="91" height="48" rx="4" fill="currentColor" fillOpacity="0.12" />
      <path
        d="M28 32l8-10 6 7 10-14 11 17H28z"
        fill="currentColor"
        fillOpacity="0.35"
      />
      <circle cx="34" cy="20" r="4" fill="currentColor" fillOpacity="0.35" />
    </svg>
  );
}

/**
 * Event poster thumbnail with graceful fallback when the image is missing or fails to load.
 */
export default function EventImageWithFallback({
  src,
  alt = "Event image",
  className = "",
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const safeSrc = typeof src === "string" ? src.trim() : "";
  const label = typeof alt === "string" && alt.trim() ? alt : "Event image";

  const rootClass = ["event-img-with-fallback", className].filter(Boolean).join(" ");

  if (!safeSrc || failed) {
    return (
      <span
        className={`${rootClass} event-img-with-fallback--placeholder`}
        role="img"
        aria-label={label}
      >
        <EventPosterPlaceholder />
      </span>
    );
  }

  return (
    <img
      className={rootClass}
      src={safeSrc}
      alt={alt}
      decoding="async"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
